// Shared by the axios interceptor and the plan screens. Kept apart from subscriptionData so the
// interceptor can use it without importing the API client back.

// Fired when the backend refuses an action because of the plan, or when a gated control is clicked
export const PLAN_BLOCKED_EVENT = "sifthire:plan-blocked";

export const PLAN_ERROR_CODES = ["PLAN_LIMIT_REACHED", "RESUME_LIMIT_REACHED", "NO_ACTIVE_PLAN"];

// NO_ACTIVE_PLAN also comes back (409) from the billing endpoints, which explain themselves inline
const BILLING_PATH = "/organisation/plan";

export const isPlanBlockedResponse = (error) => {
  const code = error?.response?.data?.code;
  if (!PLAN_ERROR_CODES.includes(code)) return false;
  return !String(error?.config?.url || "").includes(BILLING_PATH);
};

// Fired after a save that may have used up an allowance (a job, a seat, a resume, a credit), so the
// plan screens re-read usage and a button that has just run out of room is disabled straight away
export const PLAN_STALE_EVENT = "sifthire:plan-stale";

const MUTATING = ["post", "put", "patch", "delete"];

export const isPlanMutation = (response) => {
  const method = String(response?.config?.method || "").toLowerCase();
  const url = String(response?.config?.url || "");
  // The billing calls refresh the plan themselves, and login/session calls come before there is a plan
  return MUTATING.includes(method) && !url.includes(BILLING_PATH) && !url.includes("/session") && !url.includes("/api/me");
};

export const announcePlanStale = () => {
  window.dispatchEvent(new Event(PLAN_STALE_EVENT));
};

// Fired when the server refuses a request because the organisation itself is suspended or deleted, so the whole app
// can say so at once instead of each page finding out on its own
export const ORG_INACTIVE_EVENT = "sifthire:org-inactive";

const ORG_INACTIVE_CODES = ["ORGANISATION_SUSPENDED", "ORG_INACTIVE"];
// Sign-in and Super Admin calls talk about some other organisation, not the one this person is working in
const ORG_INACTIVE_IGNORED_PATHS = ["/api/admin", "/api/session", "/api/register", "/api/logout"];

export const isOrgInactiveResponse = (error) => {
  if (!ORG_INACTIVE_CODES.includes(error?.response?.data?.code)) return false;
  const url = String(error?.config?.url || "");
  return !ORG_INACTIVE_IGNORED_PATHS.some((part) => url.includes(part));
};

export const announceOrgInactive = () => {
  window.dispatchEvent(new Event(ORG_INACTIVE_EVENT));
};

export const announcePlanBlocked = (detail) => {
  window.dispatchEvent(new CustomEvent(PLAN_BLOCKED_EVENT, { detail }));
};
